import React from "react";

import { noop } from "lodash";


export const FundingProgramContext = React.createContext({
	programs: [],
	disabled: false,
	config: {},
	onFocus: noop,
	onBlur: noop,
	onChange: noop,
	errors: {},
	touched: false,
});

export const FundingProgramContextProvider = props => {
	const {
		children,
		config,
		programs,
		onChange,
		onFocus,
		onBlur,
		errors,
		touched,
	} = props;

	return (
		<FundingProgramContext.Provider
			value={{
				programs,
				disabled: config.enabled === false,
				config,
				onFocus,
				onBlur,
				onChange,
				errors,
				touched,
			}}
		>
			{children}
		</FundingProgramContext.Provider>
	);
};

